var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "deliveryAddress" } },
    [
      _c("span", { staticClass: "headerTitle" }, [
        _vm._v("Adresse de livraison")
      ]),
      _vm._v(" "),
      _vm.address
        ? _c(
            "span",
            {
              staticClass: "btn btn-secondary edit-address btnEdit",
              on: { click: _vm.edit }
            },
            [_vm._v("\n        Modifier mon adresse\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.address
        ? _c("div", { attrs: { id: "deliveryAddressSelected" } }, [
            _c("ul", [
              _c("li", { attrs: { id: "shippingAddressTitle" } }, [
                _vm._v(_vm._s(_vm.address.title))
              ]),
              _vm._v(" "),
              _c("li", { attrs: { id: "shippingAddressNames" } }, [
                _vm._v(
                  _vm._s(_vm.address.firstname) +
                    " " +
                    _vm._s(_vm.address.lastname)
                )
              ]),
              _vm._v(" "),
              _c("li", { attrs: { id: "shippingAddressAddress" } }, [
                _vm._v(
                  _vm._s(_vm.address.number) +
                    " " +
                    _vm._s(_vm.address.address1)
                )
              ]),
              _vm._v(" "),
              _c("li", { attrs: { id: "shippingAddressCountry" } }, [
                _vm._v(
                  _vm._s(_vm.address.zipcode) +
                    " " +
                    _vm._s(_vm.address.city) +
                    ", " +
                    _vm._s(_vm.address.country.name)
                )
              ]),
              _vm._v(" "),
              _c("li", { attrs: { id: "shippingAddressPhone" } }, [
                _c("i", { staticClass: "fa fa-phone" }),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.address.phone) +
                    "\n            "
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.address
        ? _c("div", { attrs: { id: "" } }, [
            _c(
              "form",
              {
                attrs: {
                  id: "shippingAddressForm",
                  name: "shippingAddress",
                  method: "post",
                  novalidate: "novalidate",
                  autocomplete: "off"
                },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    _vm.shippingAddressSubmit($event)
                  }
                }
              },
              [_vm._t("shippingAddressForm"), _vm._v(" "), _vm._m(0)],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ponroy-order-addresses-modal",
        {
          attrs: {
            id: "shippingAddressesBookModal",
            "form-name": "shippingAddressModal",
            "slot-name": "shippingAddressModalForm",
            type: "shipping"
          }
        },
        [
          _vm._t("shippingAddressModalForm", null, {
            slot: "shippingAddressModalForm"
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: { id: "deliveryAddressSubmit", type: "submit" }
        },
        [_vm._v("Valider")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33faf4ed", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33faf4ed","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/SiteBundle/Resources/assets/components/Order/OrderShippingAddress.vue
// module id = 548
// module chunks = 1